import { useContext } from 'react'
import { NotificationsContext } from '../contexts/notifications'

export function useNotifications() {
  return useContext(NotificationsContext)
}
